import React, { useEffect, useState } from "react";
import { Link} from 'react-router-dom';
import './AdminGetUsers.css';

const API_URL = process.env.REACT_APP_API_URL + "/users";

const AdminGetUsers = ({ toolKey }) => {
  const[users, setUsers] = useState([]);
  const[loading, setLoading] = useState(false);
/*   const[search, setSearch] = useState(''); */
  const [searchName, setSearchName] = useState('');
  const [searchLastname, setSearchLastname] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const[currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;  //set to 20 before production

  const filteredUsers = users.filter(user => 
    (user.name?.toLowerCase().includes(searchName.toLowerCase()) || !searchName) &&
    (user.lastname?.toLowerCase().includes(searchLastname.toLowerCase()) || !searchLastname) &&
    (user.email?.toLowerCase().includes(searchEmail.toLowerCase()) || !searchEmail)
  );

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchName, searchLastname, searchEmail]);


  const fetchUsers = () => {
    setLoading(true);
    fetch(`${API_URL}` , {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`    }
    })
      .then(res => res.json())
      .then(data => {
        setUsers(data);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchUsers();
  }, [toolKey])

  if (loading) return <div>Loading users...</div>;
  if (!users.length) return <div> No users found.</div>

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => {
        const newPage = prev - 1;
   /*      console.log("Previous page button clicked. Going to page:", newPage); */
        return newPage;
      });
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => {
        const newPage = prev + 1;
/*         console.log("Next page button clicked. Going to page:", newPage); */
        return newPage;
      });
    }
  };

  return(
    <div className="infoTable">
      <h3>GET USERS</h3>
      <p>Click on "ID" to edit desired user details</p>
      <div>
        <input 
          type="text"
          placeholder="Search Users by Name"
          value={searchName}
          onChange={e => setSearchName(e.target.value)}
        />
        <input 
          type="text"
          placeholder="Search by Last Name"
          value={searchLastname}
          onChange={e => setSearchLastname(e.target.value)}
        />
        <input
          type="email"
          placeholder="Search Users by Email"
          value={searchEmail}
          onChange={e => setSearchEmail(e.target.value)}
        ></input>
      </div>
      <table >
        <thead>
          <tr>
            <th>NAME</th>
            <th>EMAIL</th>
            <th>SUBSCRIPTION</th>
            <th className="id">ID</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map(user => (
            <tr key={user._id}>
              <td>{user.name} {user.lastname}</td>
              <td>{user.email}</td>
              <td>{user.subscriptionLevel}</td>
              <td>
                <Link to={`/admin/users/${user._id}`}>{user._id}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pageNumeration">
        <button onClick={handlePrev} >
          Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  )


}

export default AdminGetUsers;